import React from 'react'
import tw, { styled } from 'twin.macro'
import ReactPlayer from 'react-player'
import BroadbandIcon from '../../assets/broadband.inline.svg'
import GasIcon from '../../assets/gas.inline.svg'
import ElectricityIcon from '../../assets/electricity.inline.svg'

type MultisaverCardsConfig = {
    heading?: string,
    slats: Array<any>
}

const icons = {
    electricity: <ElectricityIcon />,
    broadband: <BroadbandIcon />,
    gas: <GasIcon />
}

const MultisaverOptions: React.FC<MultisaverCardsConfig> = ({ slats, heading, ...props }) => {

    return (
        <Style className='promotion multisaver-cards'>
        {heading && <h2>{heading}</h2>}
            <div className="promotion__container">
                {slats.map((slat,i) => (
                    <div className="multisaver-cards__card" key={i}  style={{'--tint': `var(--nova-${slat.tint})`}}>
                        <header>
                            {slat.icon && <div data-icon={slat.icon} className="slat__icon">{icons[slat.icon]}</div>}
                            <h3>{slat.heading}</h3>
                        </header>
                        <strong>{slat.subheading}</strong>
                        {slat.content && <p dangerouslySetInnerHTML={{__html: slat.content}} />}
                        {slat.terms && <small><ul>{slat.terms.map((term,i) => <li key={i} dangerouslySetInnerHTML={{__html: term}} />)}</ul></small>}
                        <a className="multisaver-cards__cta" href="https://novaenergy.my.salesforce-sites.com/WebResApplication">See prices</a>
                    </div>
                ))}
            </div>
        </Style>
    )
}
export default MultisaverOptions


const Style = styled.section`

    > h2 {
        ${tw `w-full text-center font-semibold text-2xl lg:text-3xl mg:text-4xl mb-10 mx-auto px-4`}
    }

    ${tw `lg:container mx-auto px-4 mt-10 lg:mt-20`}


    > .promotion__container {
        ${tw `flex flex-wrap list-none gap-x-8 gap-y-6 p-0 m-0`}

        > .multisaver-cards__card {
            ${tw `lg:flex-1 w-full`}
        }
    }

    .multisaver-cards__card {
        ${tw `bg-white p-6 antialiased relative border border-silver flex flex-col shadow-xl w-full rounded-lg`}
        box-shadow: 0 0 1em rgb(0 0 0 / 25%);

        header {
            ${tw `flex items-center gap-x-4 mb-5`}
        }

        h3 {
            ${tw `[color:var(--tint)] font-semibold text-2xl lg:text-3xl `}
        }

        .slat__icon {
            ${tw `[backgroundColor:var(--tint)] w-16 h-16 flex items-center justify-center`}
        }

        svg {
            ${tw `text-white [width:90%] [height:90%]`}
        }

        .slat__icon[data-icon="electricity"] svg {
            ${tw `text-white [width:75%] [height:75%]`}
        }

        > strong {
            ${tw `text-primary text-center w-full block font-semibold text-2xl xl:text-3xl mb-5`}
        }

        > p {
            ${tw `mt-2 text-black font-semibold text-lg lg:text-xl`}

            a {
                ${tw `text-primary`}
            }
        }

        > small {
            ${tw `text-gray-500 mt-auto pt-5 leading-snug block`}

            ul {
                ${tw `list-disc pl-4`}

                a {
                    ${tw `text-gray-500 underline hover:text-primary`}
                }
            }
        }
    }

    .multisaver-cards__cta {
        ${tw `
            relative
            z-10
            text-base
            lg:text-lg
            inline-block
            mt-4
            text-white
            font-semibold
            px-6
            lg:px-10
            py-3
            bg-teal
            leading-none
            whitespace-nowrap
            [borderRadius:4em]
            hover:bg-black
            transition-colors
            text-center
        `}
    }


`